import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1e73735a")
const _hoisted_1 = { class: "title-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
_popScopeId()

import { computed, ref, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: '未知'
  },
  color: {
    type: String,
    default: '#be9772'
  }
},
  setup(__props) {

const props = __props


const namebody = ref()

const testbody = ref()

const name = computed(() => props.name)
const type = computed(() => props.type)
const color = computed(() => props.color)

const nameBodyWidth = computed(() => {
  if (namebody.value !== undefined && namebody.value.clientWidth !== undefined) {
    return namebody.value.clientWidth
  }
  return undefined
})

const textDefaultWidth = ref<number>(0)

const showName = ref<string>('')

const compuShowName = () => {
  if (!namebody.value) {
    showName.value = ''
    return
  }
  const textWidth = textDefaultWidth.value
  const actuaWidth = (nameBodyWidth.value ? nameBodyWidth.value : namebody.value.clientWidth) - 20
  if (textWidth <= actuaWidth) {
    showName.value = ''
    return
  }

  // 单个文字平均宽度
  const oneTextWidth = textWidth / name.value.length

  // 当前能展示的宽度
  const showNum = Math.floor(actuaWidth / oneTextWidth)

  showName.value = name.value.slice(0, showNum) + '...'
}

onMounted(() => {
  textDefaultWidth.value = testbody?.value?.clientWidth
  compuShowName()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (textDefaultWidth.value < 1)
      ? (_openBlock(), _createElementBlock("h3", {
          key: 0,
          class: "title-test-width-body",
          ref: (_value, _refs) => {
            _refs['testbody'] = _value
            testbody.value = _value
          }
        }, _toDisplayString(_unref(name)), 513))
      : _createCommentVNode("", true),
    _createElementVNode("h3", null, [
      _createVNode(_component_a_tag, { color: _unref(color) }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(type)), 1)
        ]),
        _: 1
      }, 8, ["color"])
    ]),
    _createElementVNode("div", {
      class: "title-name-body",
      ref: (_value, _refs) => {
        _refs['namebody'] = _value
        namebody.value = _value
      }
    }, [
      (showName.value.length > 0)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
            _createVNode(_component_a_tooltip, { title: _unref(name) }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(showName.value), 1)
              ]),
              _: 1
            }, 8, ["title"])
          ]))
        : (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_unref(name)), 1))
    ], 512)
  ]))
}
}

})